import { Input } from '@tkww/orion-web-ds-input';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { useState } from 'react';
import {
	DIGITS_ONLY_PATTERN,
	getGuestCountError,
} from '../../../utils/guestCount';
import Styles from './styles.scss';

type OrionInputChangeEvent = {
	target: {
		value: string;
	};
};

interface GuestCountFieldProps {
	value: string;
	onChange: (value: string) => void;
}

export const GuestCountField = ({ value, onChange }: GuestCountFieldProps) => {
	const [touched, setTouched] = useState(false);
	const error = touched ? getGuestCountError(value) : undefined;

	const handleChange = (e: OrionInputChangeEvent) => {
		const newValue = e.target.value;
		if (newValue !== '' && !DIGITS_ONLY_PATTERN.test(newValue)) return;
		onChange(newValue);
	};

	const validate = () => {
		setTouched(true);
	};

	return (
		<div className={Styles.guestCountField}>
			<hr className={Styles.divider} />
			<TextBody size="lg" bold className={Styles.title}>
				Guest count
			</TextBody>
			<Input
				label="Guest count"
				name="guestCount"
				type="text"
				inputMode="numeric"
				icon="group"
				value={value}
				onChange={handleChange}
				onBlur={validate}
				state={error ? 'invalid' : 'neutral'}
				subText={error}
			/>
		</div>
	);
};
